<template>
    <div id='Dialog' v-show="visible">
        <div v-if="show_type == 'def'" class="main">
            <div class="top_close" @click="close()"></div>

            <div class="dialog_con">
                <div class="txt_con">
                    <div v-if="msg.title" class="title">{{ msg.title }}</div>
                    <div v-if="msg.con" class="con">{{ msg.con }}</div>
                </div>
                <div class="btn_area">
                    <div v-if="type == 'two'" class="cancel" @click="close()"></div>
                    <div class="confirm" @click="confirm()"></div>
                </div>
            </div>

        </div>

        <div v-if="show_type == 'video'" class="video_main" @click="close()">
            <video ref="videoplay" class="video" :src="video_src" controls="true" autoplay></video>
        </div>

    </div>

</template>

<script>
import vue from "vue";
export default vue.component('Dialog', {
    props: {
        visible: {
            type: Boolean,
            default: false
        },

        msg: Object,
    },
    data() {
        return {

        }
    },
    watch: {
        // visible(val) {
        //     if (val) {
        //         // 显示时禁止 body 滚动
        //         document.querySelector('#app').style.overflow = 'hidden';
        //     } else {
        //         // 隐藏时恢复 body 滚动
        //         document.querySelector('#app').style.overflow = '';
        //     }
        // }
    },
    beforeDestroy() {


    },
    created() {
    },
    mounted() {
    },
    methods: {
        close() {
            if (this.show_type == 'video') {
                this.$refs.videoplay.pause()
            }

            this.$emit('close')
        },
        confirm() {
            console.log('1111111111', this.msg.cb)
            this.$emit('confirm')
            this.msg.cb && this.msg.cb()
        }
    },
    computed: {

        type() {
            // one |two 可以区分1|2个按钮
            return this.msg.type || 'one'
        },
        show_type() {
            return this.msg.show_type || 'def'
        },
        video_src() {
            return this.msg.src || ''
        }
    }

})
</script>

<style scoped>
#Dialog {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    flex-flow: column;
    align-items: center;
}


.main {
    position: relative;
    width: 1035px;
    height: 562px;

    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/dialog_bg.png') no-repeat center;
    background-size: 100% auto;
    color: #643b26;
    font-family: 'xique';
    top: 26%;
}

.top_close {

    position: absolute;
    top: 90px;
    right: 5px;
    width: 100px;
    height: 100px;
}


.dialog_con {

    width: 1000px;
    height: 500px;
    color: #643b26;
    display: flex;
    flex-flow: column;
    align-items: center;
    font-size: 52px;
    margin: 11px 0 0 22px
}

.txt_con {
    display: flex;
    flex-flow: column;
    align-items: center;
    margin-top: 165px;
}

.txt_con .title {
    font-size: 55px;

}

.txt_con .con {
    font-size: 36px;
    width: 440px;
    text-align: center;
    margin-top: 14px;
}

.btn_area {
    /* border: 1px solid red; */
    width: 850px;
    height: 80px;
    display: flex;
    justify-content: space-around;
    margin-top: 58px;

}

.btn_area .cancel {
    width: 312px;
    height: 83px;

    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/dialog_cancel.png') no-repeat center;
    background-size: 100% auto;
}

.btn_area .confirm {
    width: 312px;
    height: 83px;

    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/dialog_confirm.png') no-repeat center;
    background-size: 100% auto;
}

.video_main {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

}

.video {
    width: 1000px;
    height: auto;
}
</style>